import { useaxios } from "../../../utils/useaxios";
export default (mizania_id, mizania_statement_number, mizania_directory_number, mizania_name, mizania_amount, mizania_date, mizania_category) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('mizania/update.php', { mizania_id, mizania_statement_number, mizania_directory_number, mizania_name, mizania_amount, mizania_date, mizania_category }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        } else {
            alert('تکایە دڵنیابە لە داخڵکردنی زانیاری دروست');
            initDispatch({ type: 'loadingFalse' });
        }
        // setloading(false);
    });
}